import Axios from '@/assets/js/AxiosPlugin'

// 商品列表
export const goodsListApi = params => { return Axios.post('/api/Home/Points/goodsList', params) }
// 商品详情
export const goodsInfoApi = params => { return Axios.post('/api/Home/Points/goodsInfo', params) }
// 商品兑换
export const exchangeApi = params => { return Axios.post('/api/Home/Points/exchange', params) }
// 商品兑换记录
export const exchangeListApi = params => { return Axios.post('/api/Home/Points/exchangeList', params) }



// WEBPACK FOOTER //
// ./src/views/mobile/GoodsList/apis/index.js